export default __webpack_public_path__ + "static/media/004-cat.eb169ce0.svg";